module.exports = __webpack_public_path__ + "static/img/cbuenosaires.3f72fee4.jpg";